export default "__VITE_ASSET__COPzlVfw__"